const networkData = {
    "linesOfNetwork": [
        {
            "id": "2598e63d-4b38-451a-b96e-d40db9fae192",
            "name": "Usti-Brandys_all",
            "networkId": "d347c8f8-1b8e-492a-991c-dc735f63137c",
            "railwayEdgeIds": "89d9027d-38b0-4d8b-8cbf-fd471aa2d82c"
        }
    ],
    "edgesOfNetwork": [
        {
            "railwayEdgeId": "89d9027d-38b0-4d8b-8cbf-fd471aa2d82c",
            "railwayEdgeName": "E1",
            "networkId": "d347c8f8-1b8e-492a-991c-dc735f63137c",
            "length": 4429.078759671765,
            "lineString": {
                "type": "LineString",
                "coordinates": [
                    [
                        16.335556805133823,
                        49.99116686627587
                    ],
                    [
                        16.33565872907639,
                        49.99136344832533
                    ],
                    [
                        16.33610934019089,
                        49.99217390969267
                    ],
                    [
                        16.33623003959656,
                        49.992406699262546
                    ],
                    [
                        16.336390972137455,
                        49.99269811572835
                    ],
                    [
                        16.3364714384079,
                        49.992855031555386
                    ],
                    [
                        16.3365805,
                        49.9930977
                    ],
                    [
                        16.33667260408402,
                        49.99339647344474
                    ],
                    [
                        16.336715519428257,
                        49.993698229813944
                    ],
                    [
                        16.33673965930939,
                        49.993872385485226
                    ],
                    [
                        16.336712837219242,
                        49.99430863405142
                    ],
                    [
                        16.33660286664963,
                        49.99477074284051
                    ],
                    [
                        16.33654117584229,
                        49.99493282472201
                    ],
                    [
                        16.33634001016617,
                        49.995322508712036
                    ],
                    [
                        16.335964500904087,
                        49.99584150770628
                    ],
                    [
                        16.335387825965885,
                        49.99638291596956
                    ],
                    [
                        16.33478164672852,
                        49.996789830269364
                    ],
                    [
                        16.33428,
                        49.9970568
                    ],
                    [
                        16.333818733692173,
                        49.997257087781335
                    ],
                    [
                        16.333317160606388,
                        49.997417437098726
                    ],
                    [
                        16.332815587520603,
                        49.9975536473891
                    ],
                    [
                        16.33225500583649,
                        49.99765882215944
                    ],
                    [
                        16.33178293704987,
                        49.997715719890124
                    ],
                    [
                        16.331238448619846,
                        49.99774675498759
                    ],
                    [
                        16.33074760437012,
                        49.99775192750186
                    ],
                    [
                        16.330208480358127,
                        49.99772606492485
                    ],
                    [
                        16.329669356346134,
                        49.99765537380996
                    ],
                    [
                        16.32898271083832,
                        49.99752606052601
                    ],
                    [
                        16.328628659248356,
                        49.99742950638054
                    ],
                    [
                        16.328325569629673,
                        49.99734157297221
                    ],
                    [
                        16.327705979347233,
                        49.99709501373436
                    ],
                    [
                        16.327268779277805,
                        49.99688293729454
                    ],
                    [
                        16.326713562011722,
                        49.99653464712805
                    ],
                    [
                        16.326485574245456,
                        49.99637257064586
                    ],
                    [
                        16.32617443799973,
                        49.99608290067866
                    ],
                    [
                        16.325930356979374,
                        49.99584495618585
                    ],
                    [
                        16.325651407241825,
                        49.995557007290195
                    ],
                    [
                        16.32531344890595,
                        49.995208707519275
                    ],
                    [
                        16.325053274631504,
                        49.99496213734439
                    ],
                    [
                        16.3248454,
                        49.9947749
                    ],
                    [
                        16.324591934680942,
                        49.99458107185989
                    ],
                    [
                        16.324326395988468,
                        49.99440002158959
                    ],
                    [
                        16.323787271976474,
                        49.994079302294615
                    ],
                    [
                        16.3236035,
                        49.9939904
                    ],
                    [
                        16.32314890623093,
                        49.993775824002824
                    ],
                    [
                        16.322472989559177,
                        49.99351545189644
                    ],
                    [
                        16.322220861911777,
                        49.99342923565645
                    ],
                    [
                        16.321703195571903,
                        49.99330163533765
                    ],
                    [
                        16.32136791944504,
                        49.993220591716096
                    ],
                    [
                        16.320810019969944,
                        49.99312230458752
                    ],
                    [
                        16.32026016712189,
                        49.99305677972356
                    ],
                    [
                        16.31969422101975,
                        49.99301884423518
                    ],
                    [
                        16.3191631436348,
                        49.9930102225291
                    ],
                    [
                        16.318602561950687,
                        49.99302401725809
                    ],
                    [
                        16.318041980266575,
                        49.99307057443919
                    ],
                    [
                        16.317449212074283,
                        49.99314816964084
                    ],
                    [
                        16.31726682186127,
                        49.99318265635693
                    ],
                    [
                        16.317006647586826,
                        49.99323438638471
                    ],
                    [
                        16.316435337066654,
                        49.99337578151005
                    ],
                    [
                        16.31590694189072,
                        49.99353786809348
                    ],
                    [
                        16.31539732217789,
                        49.99373271613557
                    ],
                    [
                        16.314758956432346,
                        49.994013778734654
                    ],
                    [
                        16.314209103584293,
                        49.99429483969094
                    ],
                    [
                        16.30969494581223,
                        49.99661223674001
                    ],
                    [
                        16.30888491868973,
                        49.99702432169169
                    ],
                    [
                        16.3085604,
                        49.9971866
                    ],
                    [
                        16.307948827743534,
                        49.997498473647084
                    ],
                    [
                        16.307138800621036,
                        49.99787951601164
                    ],
                    [
                        16.306377053260807,
                        49.99816917515529
                    ],
                    [
                        16.30577087402344,
                        49.998374349326255
                    ],
                    [
                        16.305127143859867,
                        49.998543315633164
                    ],
                    [
                        16.304507553577427,
                        49.9986864192858
                    ],
                    [
                        16.30382895469666,
                        49.99881572944896
                    ],
                    [
                        16.30315572023392,
                        49.99889848777087
                    ],
                    [
                        16.302477121353153,
                        49.99896228054679
                    ],
                    [
                        16.30178511142731,
                        49.99899159071274
                    ],
                    [
                        16.30154371261597,
                        49.999001935472926
                    ],
                    [
                        16.301103830337528,
                        49.99899503896639
                    ],
                    [
                        16.30039840936661,
                        49.99898469420471
                    ],
                    [
                        16.300001442432407,
                        49.99897607356828
                    ],
                    [
                        16.298255324363712,
                        49.99890193603119
                    ],
                    [
                        16.2979559,
                        49.9988943
                    ],
                    [
                        16.2921205,
                        49.9986785
                    ],
                    [
                        16.2909371,
                        49.9986554
                    ],
                    [
                        16.290307939052585,
                        49.99866228135016
                    ],
                    [
                        16.289481818676,
                        49.99872435030305
                    ],
                    [
                        16.288760304450992,
                        49.99881228118246
                    ],
                    [
                        16.288355290889744,
                        49.998874349941694
                    ]
                ]
            }
        }
    ],
    "network": [
        {
            "networkId": "d347c8f8-1b8e-492a-991c-dc735f63137c",
            "organisationsId": "62c4afed-d659-4b47-b08f-4331e6a8ff5f",
            "networkName": "Usti-Brandys",
            "networkIcon": null,
            "location": "",
            "mainCity": "",
            "country": "",
            "centerGeoPoint": {
                "type": "Point",
                "coordinates": [
                    16.31987924,
                    49.99585398
                ]
            },
            "active": 1,
            "defaultStartEdge": "89d9027d-38b0-4d8b-8cbf-fd471aa2d82c",
            "lineMeterOnDefaultStartEdge": 0,
            "defaultEndEdge": "89d9027d-38b0-4d8b-8cbf-fd471aa2d82c",
            "lineMeterOnDefaultEndEdge": 0,
            "timeStamp": "0001-01-01T00:00:00",
            "editorStepProcessed": 0,
            "edgeDataExist": false,
            "trackCount": 0
        }
    ]
}

export default networkData